import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import EquipmentsModal from './EquipmentsModal';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import VariationList from './VariationList';
import { getDecryptedUserFromCookie } from './utils/getCookie';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import { useSearch } from '../SearchContext';
import { useFilter } from '../FilterContext';
import FilterDrawer from './FilterDrawer';
import { decryptToken } from './utils/getToken';

const Equipments = () => {
    const { isSidebarOpen } = useSidebar();
    const [isOpen, setIsOpen] = useState(false);
    const token = decryptToken("accessToken") || ""
    console.log(token)
    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [Equipments, setEquipments] = useState([
    ]);
    const [filteredEquipments, setFilteredEquipments] = useState(Equipments);
    const [currentPage, setCurrentPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate()
    const urlmain = process.env.REACT_APP_LINK
    const { globalSearch } = useSearch();
    const { entriesPerPage, sortOrder, showDrawer, setShowDrawer, customDate } = useFilter();
    const [load, setLoad] = useState(false);

    const user = getDecryptedUserFromCookie("gta_mainstateuser");

    let filteredProducts = [...Equipments];

    // 1. Filter by date
    if (customDate.from || customDate.to) {
        filteredProducts = filteredProducts.filter((product) => {
            const createdAt = new Date(product.createdAt);
            const from = customDate.from ? new Date(customDate.from) : null;
            const to = customDate.to ? new Date(customDate.to) : null;

            return (!from || createdAt >= from) && (!to || createdAt <= to);
        });
    }

    // 2. Sort by date
    filteredProducts.sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });


    // Effect to handle filtering
    useEffect(() => {
        const filtered = Equipments.filter((product) =>
            Object.values(product).some((value) =>
                String(value).toLowerCase().includes(globalSearch.toLowerCase())
            )
        );
        setFilteredEquipments(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [globalSearch, Equipments]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredProducts.length / entriesPerPage);
    const currentData = filteredProducts.slice(
        (currentPage - 1) * entriesPerPage,
        currentPage * entriesPerPage
    );


    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Handle Delete
    const handleDelete = async (indexToDelete, product_id, title) => {
        const product = filteredEquipments[indexToDelete];
        const actualIndex = Equipments.findIndex(e => e.product_id === product.product_id);

        if (!product?.product_id) return;

        Swal.fire({
            title: 'Are you sure?',
            text: `This will permanently delete "${title}"`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.delete(`${urlmain}/grouped-product/${product_id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    if (response.status === 200) {
                        const updated = Equipments.filter(item => item.product_id !== product_id);
                        setEquipments(updated);
                        toast.success("Product deleted successfully");
                    }
                } catch (error) {
                    console.error(error);
                    toast.error("Failed to delete product");
                }
            }
        });
    };

    const handleNavigate = (url) => {
        navigate(url)
    };


    const toggleStatus = async (indexToToggle) => {
        const product = filteredEquipments[indexToToggle]; // From current page
        if (!product?.product_id) return;

        try {
            const res = await axios.put(
                `${urlmain}/grouped-product/toggle-status/${product.product_id}`,{},  {
                    
                headers: {
                    "Content-Type":"application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
            );
            const updatedStatus = res.data.updatedProduct.status;
            console.log(res);
            if (res.status === 200) {
                // Update full Equipments array
                const updatedEquipments = Equipments.map((item) =>
                    item.product_id === product.product_id
                        ? { ...item, status: updatedStatus }
                        : item
                );

                setEquipments(updatedEquipments); // ✅ This will auto-trigger UI update
                toast.success(`Status updated to ${updatedStatus}`);
            }


        } catch (error) {
            console.error("Failed to toggle status:", error);
        }
    };




    // const fetchData = async () => {
    //     try {
    //         const response = await axios.get(`${urlmain}/grouped-product/search-all-products/${user.main_id}`);
    //         const products = response.data.map(product => {
    //             if (product.product_type === "Variable Product" && Array.isArray(product.variation)) {
    //                 return {
    //                     ...product,
    //                     variationPrices: product.variation.map(v => v.salePrice || v.price), // Extract prices
    //                 };
    //             }
    //             return product;
    //         }).sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));;
    //         setEquipments(products.reverse());
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    const fetchData = async () => {
        setLoad(true);
        try {
            const response = await axios.get(`${urlmain}/grouped-product/search-all-products/${user.main_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const cleanedProducts = response.data.map((product) => {
                // Parse fields that are JSON strings
                const parsedProduct = {
                    ...product,
                    gallery: typeof product.gallery === "string" ? JSON.parse(product.gallery) : product.gallery,
                    key_features: typeof product.key_features === "string" ? JSON.parse(product.key_features) : product.key_features,
                    specifications: typeof product.specifications === "string" ? JSON.parse(product.specifications) : product.specifications,
                    attribute: typeof product.attribute === "string" ? JSON.parse(product.attribute) : product.attribute,
                };

                // Handle variation only for Variable Product
                if (product.product_type === "Variable Product" && typeof product.variation === "string") {
                    parsedProduct.variation = JSON.parse(product.variation);
                    parsedProduct.variationPrices = parsedProduct.variation.map(v => v.salePrice || v.price);
                }

                return parsedProduct;
            });

            // ✅ Save full product list as stringified JSON in localStorage
            localStorage.setItem("equipmentsData", JSON.stringify(cleanedProducts));

            // ✅ Update state
            setEquipments(cleanedProducts.reverse());
        } catch (error) {
            console.error("Error fetching or parsing product data:", error);
            toast.error("Failed to fetch product data.");
        } finally {
            setLoad(false)
        }
    };

    const handleNavigateMain = (pro_id, pro_type) => {
        if (pro_type === "Simple Product") {
            navigate(`/simple-productedit/${pro_id}`)
        } else if (pro_type === "Variable Product") {
            navigate(`/variableedit-product/${pro_id}`)
        } else if (pro_type === "Affiliate Product") {
            navigate(`/affiliate-productedit/${pro_id}`)
        } else if (pro_type === "Grouped Product") {
            navigate(`/grouped-productedit/${pro_id}`)
        }
    }




    useEffect(() => {
        fetchData();
    }, [])

    if (load) {
        return (
            <div className="loader-wrapper-hbtreal">
                <div className="spinner-hbtreal"></div>
                <p className="loader-text-hbtreal">Loading, Please Wait...</p>
            </div>
        );
    }


    return (
        <>
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Products</h1>
                    <div className="customer-warning-new-hamburger-help">
                        {/* Add Offers Button */}
                        <div className="property-dropdown-wrapper">
                            <button className="oms-add-btn" onClick={() => setIsOpen(!isOpen)}>
                                Add Products
                            </button>
                            {isOpen && (
                                <ul className="property-dropdown-menu">
                                    <li onClick={() => handleNavigate('/simple-product')}>
                                        Simple Product
                                    </li>
                                    <li onClick={() => handleNavigate('/grouped-product')}>
                                        Grouped Product
                                    </li>
                                    {/* 
                                <li onClick={() => handleNavigate('/external-affiliate-product')}>
                                    Affiliate Product
                                </li> */}
                                    <li onClick={() => handleNavigate('/variable-product')}>
                                        Variable Product
                                    </li>
                                </ul>
                            )}
                        </div>

                        <div className="filter-controls">
                            <button onClick={() => setShowDrawer(true)} className="more-filters-btn">
                                <i className="fa-solid fa-sliders"></i> Filters
                            </button>
                        </div>
                    </div>

                </div>



                {/* Search Filter */}
                {/* <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> 
                    </div>
                </div> */}

                {/* Equipments Table */}
                <div className="customer-table responsive-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Image</th>
                                <th>Title</th>
                                <th>Original Price</th>
                                <th>Discount Price</th>
                                <th>Category</th>
                                <th>Total</th>
                                <th>Stock</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((product, index) => {
                                    const actualIndex = Equipments.findIndex(e => e.product_id === product.product_id);
                                    return <tr key={index}>
                                        <td>
                                            <img
                                                src={`${urlmain}${product.image}`}
                                                alt={product.title}
                                                style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                            />
                                        </td>
                                        <td>{product.title}</td>

                                        {/* Original Price */}
                                        {/* Original Price Column */}
                                        <td>
                                            {product.product_type === "Variable Product" ? (
                                                <VariationList
                                                    variations={product.variation}
                                                    type="price"
                                                    productId={product.product_id}
                                                />
                                            ) : (
                                                `₹ ${product.originalPrice}`
                                            )}
                                        </td>

                                        {/* Sale Price Column */}
                                        <td>
                                            {product.product_type === "Variable Product" ? (
                                                <VariationList
                                                    variations={product.variation}
                                                    type="sale"
                                                    productId={product.product_id}
                                                />
                                            ) : (
                                                `₹ ${product.discountPrice}`
                                            )}
                                        </td>



                                        <td>{product.category || "N/A"}</td>
                                        <td>{product.total || product.totalStock || "-"}</td>
                                        <td>{product.product_type || "N/A"}</td>
                                        <td>{product.stock || "N/A"}</td>

                                        <td>
                                            <button className="toggle-button" onClick={() => toggleStatus(actualIndex)}>
                                                <i
                                                    className={
                                                        product.status === 'Active'
                                                            ? 'fas fa-toggle-on'
                                                            : 'fas fa-toggle-off'
                                                    }
                                                ></i>
                                            </button>
                                        </td>

                                        <td>
                                            <button className="edit-button" onClick={() => handleNavigateMain(product.product_id, product.product_type)}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button className="delete-button" onClick={() => handleDelete(index, product.product_id, product.title)}>
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                })
                            ) : (
                                <tr>
                                    <td colSpan="10" style={{ textAlign: 'center' }}>
                                        No Products Added.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="ecom-responsive-cards">
                    {currentData.length === 0 ? (
                        <p style={{ textAlign: "center", margin: "50px" }}>No Products Available</p>
                    ) : (
                        currentData.map((product, index) => {
                            let minSale = null;
                            let maxSale = null;
                            let minOriginal = null;
                            let maxOriginal = null;

                            if (product.product_type === "Variable Product" && Array.isArray(product.variation)) {
                                const salePrices = product.variation.map(v => parseFloat(v.salePrice)).filter(p => p > 0);
                                const originalPrices = product.variation.map(v => parseFloat(v.price)).filter(p => p > 0);

                                if (salePrices.length > 0) {
                                    minSale = Math.min(...salePrices);
                                    maxSale = Math.max(...salePrices);
                                }

                                if (originalPrices.length > 0) {
                                    minOriginal = Math.min(...originalPrices);
                                    maxOriginal = Math.max(...originalPrices);
                                }
                            }

                            return (
                                <div
                                    className="ecom-responsive-card"
                                    key={index}
                                    onClick={() => navigate(`/product-detail/${product.product_id}`)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className="ecom-responsive-header">
                                        <p>{product.product_type}</p>
                                        <p>{product.stock}</p>
                                    </div>

                                    <div className="ecom-responsive-body">
                                        <div className="ecom-responsive-left">
                                            <h2>{product.title || "No Notes Provided"}</h2>
                                            <p>{product.category || "Uncategorized"}</p>
                                        </div>

                                        <div className="ecom-responsive-right">
                                            {product.product_type === "Variable Product" ? (
                                                <>
                                                    {minSale && maxSale ? (
                                                        <h4>₹ {minSale === maxSale ? minSale : `${minSale} - ${maxSale}`}</h4>
                                                    ) : minSale ? (
                                                        <h4>₹ {minSale}</h4>
                                                    ) : maxSale ? (
                                                        <h4>₹ {maxSale}</h4>
                                                    ) : null}

                                                    {minOriginal && maxOriginal ? (
                                                        <p>₹ {minOriginal === maxOriginal ? minOriginal : `${minOriginal} - ${maxOriginal}`}</p>
                                                    ) : minOriginal ? (
                                                        <p>₹ {minOriginal}</p>
                                                    ) : maxOriginal ? (
                                                        <p>₹ {maxOriginal}</p>
                                                    ) : null}
                                                </>
                                            ) : (
                                                <>
                                                    <h4>₹ {product.discountPrice}</h4>
                                                    <p>₹ {product.originalPrice}</p>
                                                </>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            );
                        })
                    )}

                </div>

                {totalPages > 1 && (

                    <div className="pagination">
                        {/* First Page */}
                        <button
                            onClick={() => paginate(1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronsLeft size={18} />
                        </button>

                        {/* Previous Page */}
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronLeft size={18} />
                        </button>

                        {/* Current Page Number Only */}
                        <button className="pagination-btn active">
                            {currentPage}
                        </button>

                        {/* Next Page */}
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronRight size={18} />
                        </button>

                        {/* Last Page */}
                        <button
                            onClick={() => paginate(totalPages)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronsRight size={18} />
                        </button>
                    </div>
                )}


            </div>

            <EquipmentsModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
            <FilterDrawer />
        </>
    );
};

export default Equipments;


